import { Slide } from "@jelly/lesson";
import config from "appConfig";
import theory from "../../theory";

const principle: Slide = {
  title: "MUSHRA",
  description:
    "In this MUSHRA (MUltiple Stimuli with Hidden Reference and Anchor) experiment, the participant is asked to rate the quality. The six audio stimuli are created for different audio compression rates from 32 kbit/s to 320 kbit/s, randomly assigned to the conditions.",
  theory: theory,
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 2,
      rowsSize: [6, 1],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "iframe",
                options: {
                  src: `${config.IFRAMES_STATIC_URL}/0224-mushra/`,
                },
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "hint",
                options: {
                  direction: "row",
                  size: "large-thin",
                  color: "primary",
                  data:
                    "The six different conditions  also contain the (hidden) reference (320 kbit/s) and the low anchor (lowpass-filtered at 3.5 kHz). In the experiment, this information is not presented to the participant.",
                },
              },
              styles: {
                padding: "0 0",
              },
            },
          },
        ],
      ],
    },
  },
};

export default principle;
